module.exports = __webpack_public_path__ + "static/media/gustavo@2x.43212824.jpg";